exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nhtml,\nbody,\n.container-table {\n  height: 100%;\n  background-color: #282b30 !important;\n}\n.container-table {\n  display: table;\n  color: white;\n}\n.vertical-center-row {\n  display: table-cell;\n  vertical-align: middle;\n}\n.vertical-20p {\n  padding-top: 20%;\n}\n.vertical-10p {\n  padding-top: 10%;\n}\n.logo {\n  width: 15em;\n  padding: 3em;\n}\n.loginForm .input-group {\n  padding-bottom: 1em;\n  height: 4em;\n}\n.input-group input {\n  height: 4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7200540a","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/city/cityPassword.vue
// module id = 200
// module chunks = 0